<script>
  export let propuestaRevisor;
  export let onRemove;
</script>

<style>
  div.rechazarRevisionPropuesta {
    width: 100%;
    display: flex;
    color: var(--revista-black);
    border-top-color: lightgray;
    border-top-style: solid;
    border-top-width: 1px;
  }

  div.rechazarRevisionPropuesta:last-child {
    border-bottom-color: lightgray;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  div.image {
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.image img {
    width: 25px;
    height: 25px;
  }

  div.info {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: flex-start;
  }

  div.nombre {
    font-weight: bold;
  }

  div.options {
    width: 10%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  div.options img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
</style>

<div class="rechazarRevisionPropuesta">
  <div class="image">
    <img src="/images/revista/user.svg" alt="User Icon" />
  </div>
  <div class="info">
    <div class="nombre">
      <span>{propuestaRevisor.nombreCompleto}</span>
    </div>
    <div class="email">
      <span>{propuestaRevisor.email}</span>
    </div>
    <div class="institucion">
      <span>
        <i>{propuestaRevisor.institucion}</i>
      </span>
    </div>
  </div>
  <div class="options">
    <img
      src="/images/revista/close.svg"
      alt="Remove Icon"
      on:click={onRemove} />
  </div>
</div>
